<!-- <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
    <i class="pi pi-bars"></i>
  </button> -->
  <div class="exp">

    <button #menubutton class="expand-m" [ngClass]="isMenuExpanded ? 'chevron-left' : 'menu-ham'" (click)="toggleMenu()">

  </button>
          <a class="layout-topbar-logo" routerLink="/pages/maptiler" *ngIf="isMenuExpanded" (click)="toggleMenu()">
              <!-- <img class="app-logo" src="assets/layout/images/{{layoutService.config.colorScheme === 'light' ? 'logo-dark' : 'logo-white'}}.svg" alt="logo"> -->
              <!-- <span>GeoPerform</span> -->
              <!-- <img class="app-logo" src="assets/layout/images/GeoPerform_Logo.png" alt="logo"> -->
              <span><img class="name-logo"  src="assets/layout/images/gp-inner-logo.svg" alt="Geologo"></span>
          </a>
        </div>

<ul class="layout-menu">

    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>

</ul>


<app-custom (menuExpandableCase)="onExpantable()" ></app-custom>
